module.exports = __webpack_public_path__ + "media/images/pages/primary-toolkit/primary-enrichment-f77e8538b1f5a6cbc8038ffc13c5da6d.jpeg";